<script>
    import {changeAutogeneratedEmail, resetPassword, buyTrial} from "../lib/ApiRequests.svelte";
    import {validateEmail} from "../lib/Common.svelte";
    import LoadingIcon from "./LoadingIcon.svelte";
    import {navigate} from "svelte-routing";
    import {orderId} from "../routes/Order.svelte";
    import {loadPaySelection} from "../lib/OrdersHelper";
    import {_} from '../lib/i18n';

    export let identity = {};
    export let tariff = {};
    export let price;
    $: price = tariff ? tariff.totalPrice : 1;

    export let language;
    export let path;

    export let bindCardPrice = 1;
    export let bindCardCurrency = '₽';
    export let period;
    $: period = tariff ? tariff.period : 7;

    let error = '';
    let termsAccepted = false;
    export let enableReviews = true;

    let email = '';
    let errorCode;
    let emailExistsError = false;

    let isLoading = false;
    async function initCardBind() {
        error = '';
        emailExistsError = false;
        if (identity.is_temporary_email && (email.length < 7 || !validateEmail(email))) {
            error = $_('bindCard.wrongEmailFormatError');
            return;
        }

        if (identity.is_temporary_email) {
            try {
                isLoading = true;
                const changeEmailResponse = await changeAutogeneratedEmail(email);
                if (changeEmailResponse.status === 'ok') {
                    identity.email = email;
                    identity.is_temporary_email = false;
                    identity.changeKeyValue('email', email);
                    identity.changeKeyValue('is_temporary_email', false);


                } else {
                    errorCode = changeEmailResponse.error_code;
                    switch (errorCode) {
                        case 'user_exists':
                            emailExistsError = true;
                            break;
                        default:
                            error = changeEmailResponse.message;
                            break;
                    }

                }
            } catch (err) {
                console.error(err);
            }
        }

        if (!identity.is_temporary_email) {
            try {
                isLoading = true;
                const response = await buyTrial('dashboard', window.shared.testGroupPaySelection === 'b' ? 'payselection' : 'yandex_kassa');
                if (response.status === 'ok')
                {
                    // Оплата через payselection
                    if (response.hasOwnProperty('config') && response.config.hasOwnProperty('agent') && response.config.agent === 'payselection') {
                        const timer = setInterval(() => {
                            console.log('tick');
                            if (window.pw) {
                                loadPaySelection(response.config, response.invoiceId)
                                clearInterval(timer);
                                isLoading = false;
                                console.log('cleared');
                            }
                        }, 250);
                        return;
                    } else {
                        // Оплата через другой виджет
                        navigate(`${path}/dashboard/order/${response.invoiceId}`);
                    }
                }
            } catch (err) {
                console.error(err);
            }
        }

        isLoading = false;
    }

    async function resetPasswordRequest() {
        error = '';
        emailExistsError = false;

        isLoading = true;
        const response = await resetPassword(email, language);
        if (response.status === 'error') {
            error = $_('bindCard.unableToCreatePasswordRecoveryRequest');
        }

        isLoading = false;
    }
</script>

<section class="card-bind-block tail">
    <h2 class="card-bind-block__title tail__title">{$_('bindCard.titleLabel')}</h2>
    {#if enableReviews}
    <div class="card-bind-block__rating-wrapper">
            <div class="reviews-wrap">
                <div class="review-star"></div>
                <div class="review-star"></div>
                <div class="review-star"></div>
                <div class="review-star"></div>
                <div class="review-star"></div>
            </div>
    </div>
    {/if}
    <p class="card-bind-block__text tail__text">
        {@html $_('bindCard.description', {
            values: {
                bindCardPrice,
                bindCardCurrency
            }
        })}
    </p>
    <div class="card-bind-block__form-wrapper form">
        <div class="card-bind-block__agreement">
            <label class="general-checkbox card-bind-block__agreement-checkbox">
                <input class="general-checkbox__input" type="checkbox" bind:checked={termsAccepted} />
                <div class="general-checkbox__checkmark"></div>
            </label>
            <p class="card-bind-block__agreement-text">
                {@html $_('bindCard.termsAcceptanceLabel')}
            </p>
        </div>

        {#if identity.is_temporary_email}
            <input type="email" class="general-input card-bind-block__input"
                   placeholder={$_('bindCard.emailInputPlaceholder')}
                   bind:value={email}
            />
        {/if}

        <button class="button button_shadow card-bind-block__btn"
                disabled={!termsAccepted || isLoading}
                on:click={initCardBind}
        >
            <LoadingIcon show={isLoading} width="16" height="16" />
            {$_('bindCard.tryForFreeLabel')}
        </button>

        {#if error}
            <p class="card-bind-block__form-error tail__error">{error}</p>
        {/if}

        {#if emailExistsError}
            <p class="card-bind-block__form-error tail__error">
                {@html $_('bindCard.emailExistsError', {
                    values: {email},
                })} <br />
                <a href="/" class="card-bind-block__form-error-link tail__error-link" on:click|preventDefault={resetPasswordRequest}>
                    {$_('bindCard.recoverPasswordBtnLabel')}
                </a>
            </p>
        {/if}
    </div>
    <p class="card-bind-block__disclaimer">
        {@html $_('bindCard.disclaimer', {
            values: {
                price: price,
                period: period,
            },
        })}
    </p>
</section>


<style>
    .reviews-wrap {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-bottom: 17px;
    }
    .review-star {
        display: block;
        margin-right: 7px;
        width: 22px;
        height: 21px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 21' %3E%3Cpath d='M21.5355 7.85341H13.3285L10.7935 0.0869598L8.25053 7.85341L0.043457 7.84553L6.68992 12.6503L4.14699 20.4089L10.7935 15.612L17.432 20.4089L14.897 12.6503L21.5355 7.85341Z' fill='%23E7AD4B'/%3E%3Cpath d='M15.4675 14.4068L14.8971 12.6503L10.7936 15.612L15.4675 14.4068Z' fill='%23005128'/%3E%3C/svg%3E");
    }
</style>